import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { ConfigProvider } from "@h3/antd-vue";
import OAuthApi from "@/apis/oauth";
import env from "@/config/env";
import zhCN from "@h3/antd-vue/lib/locale-provider/zh_CN";
import enUS from "@h3/antd-vue/lib/locale-provider/en_US";
import app from "@cloudpivot/common/src/constants/globalApplication";
let App = class App extends Vue {
    get locale() {
        switch (this.$i18n.locale) {
            case "zh":
            default:
                // return require('@h3/antd-vue/lib/locale-provider/zh_CN');
                return zhCN;
            case "en":
                // return require('@h3/antd-vue/lib/locale-provider/en_US');
                return enUS;
        }
    }
    get isIe() {
        if (window.Environment && window.Environment.isIe !== undefined) {
            return window.Environment.isIe;
        }
        return false;
    }
    mounted() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield OAuthApi.getSystemConfig();
            if (config) {
                config.apiHost = env.apiHost;
                this.$store.commit("setConfig", config);
            }
            app.errorManager.getErrorCode();
        });
    }
};
App = tslib_1.__decorate([
    Component({
        components: {
            AConfigProvider: ConfigProvider,
        },
    })
], App);
export default App;
